import { render, staticRenderFns } from "./CorrectListExpand.vue?vue&type=template&id=87e68ea2&scoped=true&"
import script from "./CorrectListExpand.vue?vue&type=script&lang=js&"
export * from "./CorrectListExpand.vue?vue&type=script&lang=js&"
import style0 from "./CorrectListExpand.vue?vue&type=style&index=0&id=87e68ea2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87e68ea2",
  null
  
)

export default component.exports